import React, { useContext, useState } from 'react';
import { Button, Modal, Flex} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { BuyContext } from './Workflow';
import { ModelContext } from './metadata/ModelSource';
import { navigateWithData } from '../navigation/navigationHistory';
import {ConfigContext} from 'portal-core/components/PortalApp';
import {formatMoneyAmount} from '../utils/formatUtils';
import {EstimatedQuoteText} from '../../../app/config/HtmlFormatedText'
import {ApplicationActionsContext} from "./data/ApplicationDataSource";
import { onSubmitAgent } from '../api/applicationAPI';

export const EstimatedQuote = ({ title, disableButton }) => {
  const { isValid } = useContext(BuyContext);
  const [state, setState] = useState({
    showContact: false,
    isLoading: false
  });
  const applicationModel = useContext(ModelContext);
  const config = useContext(ConfigContext);
  const { saveApplication } = useContext(ApplicationActionsContext);
  const applicationAdvanceText = config.branding.buttons.applicationAdvance ? config.branding.buttons.quoteAdvance : 'Apply';

  const total =
      parseFloat(applicationModel.data.basicPolicy.writtenPremiumAmt) +
      parseFloat(applicationModel.data.basicPolicy.writtenFeeAmt);

  const totalAmt = isNaN(total) ? '$0.00' : formatMoneyAmount(total);
  const applicationNumber = applicationModel.data.applicationNumber;

  return (
      <div className="estimated-prem" style={styles.container}>
        <h5 id='estimated-prem-title'style={styles.title}>
          {title ? title.toUpperCase() : 'ESTIMATED PREMIUM'}
        </h5>
        <h2 style={styles.amountText}>
          <span style={{ fontWeight: 800 }}>{totalAmt}</span>/{applicationModel.data.basicPolicy.renewalTermCd}
        </h2>
        <EstimatedQuoteText productVersionIdRef={applicationModel.data.basicPolicy.productVersionIdRef}/>
        <div
        style={{
          display: 'flex',
        }}
        >
          { !disableButton &&
            <Button
                type="primary"
                onClick={() => {
                  onSubmitAgent(applicationModel.data.systemId, applicationNumber);
                }}
                loading={state.isLoading}
                disabled={!isValid}
                style={{
                  width: '100px',
                }}
            >
              {applicationAdvanceText}
            </Button>
          }
          <Modal
            visible={state.showContact}
            footer={null}
            onCancel={() => {
              setState({
                showContact: false,
              });
            }}
            footer={null}
            closable
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                padding: '32px',
              }}
            >
              <div style={{ marginTop: '16px' }}>
                <p>
                  Connect with our Collector Vehicle Specialist: <a href="tel:8556638558">(855-663-8558)</a>
                </p>
              </div>
            </div>
          </Modal>
        </div>
      </div>
  );
};

const styles = {
  amountText: {
    fontSize: '26px',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 'auto',
    marginBottom: '30px',
  },
  title: {
    fontSize: '18px',
  },
};